import React, { useMemo, memo } from "react";
import Dropdown from "../../dropdown/dropdown";
import { displayCardNetwork } from "../../../actions/helpers";

type OnSelect = (network: string, key: string) => void;
const NetworkItem = ({ value }: { value?: string }) => (
	<div className={`item card small`}>
		<div className="itemBody">
			<div className="cardNumber">{displayCardNetwork(value)}</div>
		</div>
	</div>
);
const CardDropdown = ({
	value,
	onItemSelect,
	networks,
}: {
	value: string;
	onItemSelect: OnSelect;
	networks: string[];
}) => {
	let selectedValue = value;

	let options = useMemo(() => {
		return networks.map((option, key) => <NetworkItem key={key} value={option} />);
	}, [networks]);

	return (
		<div className="select card">
			<Dropdown value={selectedValue} onItemSelect={onItemSelect}>
				{options}
			</Dropdown>
		</div>
	);
};

function NetworkSelect({ input: { onChange, value, name }, card, ...rest }) {
	const onItemSelect = (network: string) => {
		onChange(network);
	};
	if (!value && card?.networks?.available?.length > 1) {
		value = card.networks.preferred || card.networks.available[0];
		onChange(value);
	}
	return <CardDropdown networks={card?.networks?.available || []} value={value} onItemSelect={onItemSelect} />;
}

export default memo(NetworkSelect);
